import React, { lazy, Suspense } from "react";
import { Route, Routes } from 'react-router-dom';
import { HOME_URL } from "../constants/appRoutes";
import Page404 from "./Page404";
import Loading from "./Loading";

const Home = lazy(() => import("../pages/Home"));

const AppRoute: React.FC = () => {
  return (
    <Suspense fallback={<Loading />}>
        <Routes>
          <Route path={`${HOME_URL}*`} element={<Home />} />
          <Route element={<Page404 />} />
        </Routes>
    </Suspense>
  );
};

export default AppRoute;
